import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

import * as actions from '../../constants';
import { callAPI } from '../../middleware';

var decodeTokenRequest = function decodeTokenRequest() {
  return {
    type: actions.DECODE_TOKEN_REQUEST
  };
};

var decodeTokenSuccess = function decodeTokenSuccess(content) {
  return {
    type: actions.DECODE_TOKEN_SUCCESS,
    payload: content
  };
};

var decodeTokenFailure = function decodeTokenFailure(error) {
  return {
    type: actions.DECODE_TOKEN_FAILURE,
    error: error
  };
};

export var decodeToken = function decodeToken(token) {
  return function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var body, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(decodeTokenRequest());
              _context.prev = 1;
              body = {
                token: token
              };
              _context.next = 5;
              return callAPI({
                method: 'GET',
                endpoint: '/account/auth/decodetoken',
                body: body
              });

            case 5:
              response = _context.sent;
              dispatch(decodeTokenSuccess(response));
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](1);
              dispatch(decodeTokenFailure(_context.t0));
              console.error(_context.t0);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 9]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};